module.exports = __webpack_public_path__ + "media/assets/arrow_down-480938bf2f3a9f50f1417dd26a0cadcd.svg";